exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer .wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center; }\n\n.footer .line {\n  border: 1px solid #555; }\n\n.footer .link {\n  text-decoration: underline;\n  color: inherit;\n  font-weight: bold; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Footer/Contact/index.scss
// module id = 639
// module chunks = 0